module.exports = __webpack_public_path__ + "static/product-pa50-olive-drab-c629529a88cce0207205b607fea48651.png";